module.exports = __webpack_public_path__ + "static/module-paypal-4af6206840c5de84c4a47a282d9cf573.jpg";